<template>
	<b-modal v-model="isActive" has-modal-card @close="closeModal()" :can-cancel="false">
		<div class="modal-card modalCardContainer"
			style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
			<header class="modal-card-head" style="background-color: rgba(40, 40, 40, 1); color: white">
				Geplante An- und Abwesenheiten für den {{ headerDate }}
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: #313131">
				<div class="is-flex is-flex-direction-column">
					<div>
						<strong> Geplante Anwesenheiten: </strong> 
						<div>
							<div v-for="(presenceEvent, index ) in presenceEvents" :key="index" class="align-content-center" style="display: inline-flex">
								<p> {{ presenceEvent.attributes.name }} </p>
								<div class="ml-2" style="width:30px; height:30px; border-radius: 5px"
								:style="{ 'background-color':  presenceEvent.attributes.color }"></div>
							</div>
						</div>
					</div>
					<hr style="height: 1px; background-color: black; margin-top: 0.5rem; margin-bottom: 0.5rem;"/>
					<div>
						<strong> Geplante Abwesenheiten: </strong> 
						<div>
							<div v-for="(absenceEvent, index ) in absenceEvents" :key="index" class="align-content-center" style="display: inline-flex">
								<p> {{ absenceEvent.attributes.name }} </p>
								<div class="ml-2" style="width:30px; height:30px; border-radius: 5px"
									:style="{ 'background-color':  absenceEvent.attributes.color }"></div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot footerContainer" style=" color: white">
				<b-button @click="closeModal()" type="is-primary">
					Schließen
				</b-button>
			</footer>
		</div>
	</b-modal>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
	name: "CalendarEventModal",
	components: {},
	props: ["value", "eventArray"],
	data() {
		return {
			absenceEvents: [],
			presenceEvents: [],
		};
	},
	watch: {
		eventArray(newVal) {
			if (newVal) {
				newVal.forEach(eventDate => {
					this.presenceReasons.forEach(presenceReason => {
						if (eventDate.type == (presenceReason.attributes.name.replace(".", '')).replace(/\s/g, "")) {
							this.presenceEvents.push(presenceReason)
						}
					});
					this.absenceReasons.forEach(absenceeReason => {
						if (eventDate.type == (absenceeReason.attributes.name.replace(".", '')).replace(/\s/g, "")) {
							this.absenceEvents.push(absenceeReason)
						}
					});
				});
			}
		}
	},
	mounted() { },
	computed: {
		...mapGetters({
			absenceReasons: "absence/getData",
			presenceReasons: "presence/getData",
		}),
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		headerDate() {
			if (this.eventArray[0]) {
				return this.eventArray[0].date.toLocaleDateString(
					"de-DE",
					{
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
					}
				)
			} else {
				return undefined
			}
		}
	},
	methods: {
		closeModal() {
			this.isActive = false;
			this.absenceEvents = [];
			this.presenceEvents = []
		},
	}
}

</script>



<style scoped></style>